import React from 'react';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About Rishabh Enterprises</h1>
            <p className="text-xl text-primary-100">
              Your Trusted Partner in FASTag Solutions Since [Year]
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="text-3xl font-bold mb-6 text-neutral-900">Who We Are</h2>
                <p className="text-neutral-700 mb-4">
                  Rishabh Enterprises is an authorized FASTag service provider partnered with India's leading banks -
                  SBI and IDFC First Bank. We bridge the gap between banks, agents, and vehicle owners across India,
                  making toll payments seamless and hassle-free.
                </p>
                <p className="text-neutral-700 mb-4">
                  Our mission is to simplify the FASTag ecosystem by providing end-to-end solutions - from agent
                  registration to doorstep delivery for individual customers.
                </p>
                <p className="text-neutral-700">
                  With years of experience in the industry, we've successfully onboarded thousands of agents and
                  served countless customers nationwide.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-6 text-neutral-900">Our Mission</h2>
                <div className="space-y-4">
                  <div className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="text-xl font-semibold mb-2 text-primary">Accessibility</h3>
                    <p className="text-neutral-700">
                      Making FASTag services accessible to everyone, everywhere in India through our extensive
                      agent network and direct customer services.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="text-xl font-semibold mb-2 text-primary">Reliability</h3>
                    <p className="text-neutral-700">
                      Providing 24/7 support and ensuring seamless service delivery with zero compromises on quality.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="text-xl font-semibold mb-2 text-primary">Innovation</h3>
                    <p className="text-neutral-700">
                      Continuously improving our processes to offer the fastest and most convenient FASTag solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <h2 className="text-3xl font-bold mb-8 text-center text-neutral-900">Why Choose Us</h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-neutral-900">Official Authorization</h3>
                  <p className="text-neutral-700">
                    Certified partner with SBI and IDFC First Bank, ensuring authentic and secure FASTag services.
                  </p>
                </div>

                <div className="text-center">
                  <div className="bg-secondary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-neutral-900">Extensive Network</h3>
                  <p className="text-neutral-700">
                    Thousands of active agents nationwide, providing local support and personalized service.
                  </p>
                </div>

                <div className="text-center">
                  <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-neutral-900">Fast Processing</h3>
                  <p className="text-neutral-700">
                    Quick verification, instant activation, and express delivery for a seamless experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-16 bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">Join Our Growing Family</h2>
              <p className="text-xl mb-8 text-primary-100">
                Whether you're looking to become an agent or get your FASTag delivered home, we're here to help.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a
                  href="/#agent-form"
                  className="bg-white text-primary px-8 py-4 rounded-lg font-semibold hover:bg-primary-50 transition shadow-lg"
                >
                  Become an Agent
                </a>
                <a
                  href="/#customer-form"
                  className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary transition"
                >
                  Get Your FASTag
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
